import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { PartnerStore, PartnerState } from './partner.store';

@Injectable({ providedIn: 'root' })
export class PartnerQuery extends QueryEntity<PartnerState> {

  constructor(protected store: PartnerStore) {
    super(store);
  }

}
